import { useContext, useMemo } from 'react';
import useSWR from 'swr';
import FeedbackContext from '@/contexts/feedback';
import { fetcher } from '@/plugins/graphql';
type Notice = {
  id: number;
  is_publish: boolean;
  label: string;
  content: string;
  modal_title: string;
  modal_content: string;
  notice_target: number;
  start_datetime: string;
  end_datetime: string;
};
const useGetSystemNotice = () => {
  const { heightNotice } = useContext(FeedbackContext);
  const query = useMemo(() => {
    return `{
      admin_spohabi_notice(where: {is_publish: {_eq: true}}) {
        id
        is_publish
        label
        content
        modal_title
        modal_content
        start_datetime
        end_datetime
        notice_target
      }
    }`;
  }, []);

  const paddingTop = useMemo(() => {
    if (heightNotice > 0) {
      return heightNotice + 82;
    }
    return 82;
  }, [heightNotice]);

  const { data } = useSWR(query, fetcher, {
    revalidateOnFocus: false,
  });
  const notice: Notice = useMemo(() => {
    const noticeData = data?.[`admin_spohabi_notice`] ? data[`admin_spohabi_notice`][0] : null;
    return noticeData;
  }, [data]);
  return { notice, paddingTop };
};

export default useGetSystemNotice;
